module.exports = __webpack_public_path__ + "front/img/home-nav-bg.5e7a6737.png";